// import React from "react";
// import "./Styles.css";

// const roles = [
//   "The Listener",
//   "The Motivator",
//   "The Romantic",
//   "The Playful Friend",
//   "The Intellectual",
//   "The Storyteller",
//   "The Supportive Guide",
//   "The Coach",
//   "The Language Buddy",
//   "The Dreamer",
//   "The Caretaker",
//   "Your 3AM Friend",
// ];

// export default function companion() {
//   return (
//     <div className="features-wrapper">
//       <div className="register-btn-wrap">
//         <button
//           className="gradient-button shadow-lg"
//           onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//         >
//           Pre - Register
//         </button>
//       </div>

//       <main className="features-main">
//         <h1 className="features-heading">
//           Your Companion <span className="gradient-text">Your Way</span>
//         </h1>

//         <p className="features-sub">
//           Guftagu adapts to you — learning your style, mood, and preferences
//           until it feels like the perfect
//           <span className="gradient-text"> companion designed just for you</span>
//         </p>

//         <div className="roles-container">
//           {roles.map((role, i) => (
//             <button key={i} className="role-button">
//               {role}
//             </button>
//           ))}
//         </div>
//       </main>
//     </div>
//   );
// }

import React, { useEffect } from "react";
import "./Styles.css";
import AOS from "aos";
import "aos/dist/aos.css";

const roles = [
  "The Listener",
  "The Motivator",
  "The Romantic",
  "The Playful Friend",
  "The Intellectual",
  "The Storyteller",
  "The Supportive Guide",
  "The Coach",
  "The Language Buddy",
  "The Dreamer",
  "The Caretaker",
  "Your 3AM Friend",
];

export default function Companion() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS once
  }, []);

  return (
    <div className="features-wrapper">
      <div className="register-btn-wrap" data-aos="fade-down">
        <button
          className="gradient-button shadow-lg"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Pre - Register
        </button>
      </div>

      <main className="features-main">
        <h1 className="features-heading" data-aos="fade-up">
          Your Companion <span className="gradient-text">Your Way</span>
        </h1>

        <p className="features-sub" data-aos="fade-up" data-aos-delay="200">
          gupsy adapts to you — learning your style, mood, and preferences
          until it feels like the perfect
          <span className="gradient-text"> companion designed just for you</span>
        </p>

        <div className="roles-container" data-aos="zoom-in" data-aos-delay="400">
          {roles.map((role, i) => (
            <button key={i} className="role-button" data-aos="fade-up" data-aos-delay={i * 100}>
              {role}
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
